import { useQuery } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { AppLoader } from '~/components/loader'
// import { scaleOptions } from '~/features/criteria-forms/constants'
import { LinkButton } from '~/features/navigation'
import { useCurrentOrganization } from '~/hooks'
import { useTRPC } from '~/services/trpc'

import { Button } from '@hap/components'

export const Route = createFileRoute('/_authenticated/$alias/v2/scorecard/$scorecardId')({
  component: RouteComponent,
})

function RouteComponent() {
  const trpc = useTRPC()
  const params = Route.useParams()
  // const queryClient = useQueryClient()
  const organization = useCurrentOrganization()
  const { jobId } = Route.useSearch()
  // const { send, subscribe, status } = useContext(JobContext)
  const { data: scorecard } = useQuery(
    trpc.scorecards.getById.queryOptions(params.scorecardId),
  )

  if (!scorecard) return <AppLoader />
  return (
    <div className="bg-accent fixed inset-0 z-10 flex flex-col">
      {/*<div className="flex shrink-0 items-center justify-between border-b">
        <div className="flex items-center p-2">
          <LinkButton
            variant="ghost"
            to="/_authenticated/$alias/v2"
            from={Route.fullPath}
            size="icon"
          >
            <Icon name="arrow-left" size={12} />
          </LinkButton>
          <h1 className="font-semibold">{scorecard.name}</h1>
        </div>

        <div className="justify-cener flex items-center gap-4 p-2">
          <a href="" className="">
            Rubric
          </a>
          <a href="" className="">
            Insights
          </a>
          <a href="" className="">
            Testing Dataset
          </a>
        </div>

        <div className="shrink-0 p-2">
          <CurrentUserMenu />
        </div>
      </div>*/}
      <div className="flex h-0 shrink grow items-stretch">
        <div className="w-full max-w-4xl shrink-0 grow space-y-4 overflow-y-auto border-r p-6">
          <h2 className="text-lg font-semibold">Scorecard</h2>
          {scorecard.sections.map((section) => (
            <section
              key={section.id}
              className="border-foreground/40 bg-background border"
            >
              <header className="border-foreground/40 border-b p-2">
                <h2 className="font-semibold">{section.name}</h2>
              </header>
              <div>
                {section.criteria.map((criteria) => {
                  // const currentValue = scaleOptions.find(
                  //   (option) => option.value === criteria.criterion.scale,
                  // )
                  return (
                    <div
                      key={criteria.id}
                      className="border-b-foreground/40 flex items-center gap-10 border-b p-2 last:border-b-0"
                    >
                      <div className="shrink grow">
                        <h3 className="font-semibold">{criteria.criterion.name}</h3>
                        <p className="hidden">
                          {criteria.definition || criteria.criterion.defaultDefinition}
                        </p>
                      </div>

                      <div>
                        <LinkButton
                          to="/$alias/v2/scorecard/$scorecardId/criteria/$criteriaId"
                          params={{ criteriaId: criteria.id }}
                          from={Route.fullPath}
                          variant="ghost"
                        >
                          Edit
                        </LinkButton>
                      </div>
                    </div>
                  )
                })}
              </div>
            </section>
          ))}

          <div>
            <div></div>
            <div>
              <h3 className="font-semibold">Scorecard Summary</h3>
            </div>
          </div>
        </div>
        <div className="shrink grow overflow-y-auto p-4">
          <div>
            <h2 className="text-lg font-semibold">Resources</h2>
            {scorecard.fileUploads.map((_, key) => {
              return (
                <div
                  key={key}
                  className="border-foreground/40 flex items-center gap-4 border p-2"
                >
                  {/*<div className="shrink grow">{fileUpload.name}</div>*/}
                  <Button
                    variant="lime"
                    onClick={() => {
                      if (jobId && organization && status === 'open') {
                        // send({
                        //   type: 'start_job',
                        //   jobId: jobId,
                        //   organizationId: organization.id,
                        // })
                        // subscribe((response) => {
                        //   console.log('update', response)
                        //   const myQueryKey = trpc.scorecards.getById.queryKey(
                        //     params.scorecardId,
                        //   )
                        //   queryClient.invalidateQueries({ queryKey: myQueryKey })
                        // })
                      }
                    }}
                  >
                    Regenerate w/ Doc
                  </Button>
                </div>
              )
            })}
          </div>

          {/*<div>
            <h2 className="text-lg font-semibold">Accuracy</h2>

            <div className="border-foreground/40 border p-4">
              <h2>80%</h2>
              <Button size="sm">Add ground truths</Button>
            </div>
          </div>

          <div>
            <h2 className="text-lg font-semibold">Setup progress</h2>
            <div className="border-foreground/40 border p-4">
              <ul>
                <li>Create scorecard</li>
                <li>Upload calls</li>
                <li>Tune Scorecard</li>
                <li>Publish</li>
              </ul>
            </div>
          </div>*/}

          <Outlet />
        </div>
      </div>
    </div>
  )
}
